import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import {
  getSelected,
  makeGetVisibleMailClassNodes,
} from '../redux/selectors/MailClassesSelectors';
import {
  deSelectAllMailClasses,
  mailClassSelected,
  selectAllMailClasses,
} from '../redux/actions/ProductActions';

class MailCategoryItemSelectorContainer extends Component {
  mailClassSelected = selected => this.props.mailClassSelected(this.props.mailCategory, selected);

  selectAll = () => this.props.selectAllMailClasses(this.props.mailCategory);

  deSelectAll = () => this.props.deSelectAllMailClasses(this.props.mailCategory);

  render() {
    if (
      this.props.nodes.length === 0 || (this.props.showOnlySelected && this.props.selected.length === 0)
    ) return <div />;

    const categoryWrappedNodes = [
      {
        value: this.props.mailCategory,
        label: this.props.description,
        children: this.props.nodes || [],
      },
    ];
    return (
      <CheckboxTreeSelector
        title=""
        nodes={categoryWrappedNodes}
        expanded={[]}
        onExpand={this.mailClassExpanded}
        expandDisabled={this.props.expandDisabled}
        onSelect={this.mailClassSelected}
        selected={this.props.selected}
        onSelectAll={this.selectAll}
        onDeSelectAll={this.deSelectAll}
        allSelectorDisabled
      />
    );
  }
}

function makeMapStateToProps() {
  const getVisibleMailClassNodes = makeGetVisibleMailClassNodes();
  const mapStateToProps = (state, props) => ({
    nodes: getVisibleMailClassNodes(state, props),
    selected: getSelected(state, props),
  });
  return mapStateToProps;
}

const mapDispatchToProps = dispatch => bindActionCreators({
  mailClassSelected,
  selectAllMailClasses,
  deSelectAllMailClasses,
}, dispatch);

MailCategoryItemSelectorContainer.propTypes = {
  mailClassSelected: PropTypes.func,
  mailCategory: PropTypes.string,
  selectAllMailClasses: PropTypes.func,
  deSelectAllMailClasses: PropTypes.func,
  description: PropTypes.string,
  nodes: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line react/no-unused-prop-types
  expanded: PropTypes.arrayOf(PropTypes.string),
  expandDisabled: PropTypes.bool,
  selected: PropTypes.arrayOf(PropTypes.string),
  showOnlySelected: PropTypes.bool,
};

export default connect(makeMapStateToProps, mapDispatchToProps)(MailCategoryItemSelectorContainer);
